import { render, staticRenderFns } from "./web-store.vue?vue&type=template&id=55dd1676"
import script from "./web-store.vue?vue&type=script&lang=js"
export * from "./web-store.vue?vue&type=script&lang=js"
import style0 from "./web-store.vue?vue&type=style&index=0&id=55dd1676&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports